import gql from 'graphql-tag'

export const VideosTable_video = gql`
  fragment VideosTable_video on Video {
    id
    title
    archived
    insertedAt
    lastViewedAt
    thumbnailUrl

    clips(first: 1) {
      edges {
        node {
          __typename
          id
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/routes/videos/components/VideosTable.fragments.js